import { assetApiBase } from './config';
import { markUploaded } from './assetCloud';
import { currentAccessToken } from '../auth/useAuth';

/**
 * Re-host a remote image (e.g. a stock-photo `fullUrl`) through the asset
 * service's Cognito-gated /import route: the server fetches the bytes, stores
 * them in the origin bucket under their content hash, and returns the id. We
 * mark it uploaded so the resolver serves it from the CDN. Returns the asset id.
 */
export async function importStockAsset(url: string): Promise<string> {
  const token = currentAccessToken();
  const res = await fetch(`${assetApiBase()}/import`, {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      ...(token ? { authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({ url }),
  });
  if (!res.ok) throw new Error(`import failed: HTTP ${res.status}`);
  const { id } = (await res.json()) as { id: string };
  markUploaded(id);
  return id;
}
